
















import { Component } from 'nuxt-property-decorator'
import ActivityContent from './card/index.vue'
import ActivityFooter from './footer.vue'
import TourBusinessBase from '~/components/tour/tour-base/business-base'
import commonSectionStructure from '~/components/tour/section-list/common/base.vue'

@Component({
  components: {
    ActivityContent,
    ActivityFooter,
    commonSectionStructure
  }
})
export default class TourRecommendCategorySection extends TourBusinessBase {
  static displayName = 'ExperienceCategory_recommend'

  get cardSections() {
    return this.businessData?.list || []
  }

  get title() {
    return this.businessData?.title || ''
  }

  get footerProps() {
    const { button, button_deeplink } = this.businessData || {}

    return {
      text: button,
      link: button_deeplink
    }
  }
}
